import {version} from "./version";

let server = {
    'local': `https://api.rbnrewards.com`,
    'dev': `https://dev.api.rbnrewards.com`,
    'staging': `https://api.rbnrewards.com`,
    'production': `https://api.rbnrewards.com`,
}[version] || `https://api.rbnrewards.com`;

let endpoint = `${server}/api`;

export const api = {
    server,
    endpoint
};